import { authFetch } from "~/services/fetch";

interface getAssociatedSearchLogsProps {
  readonly searchType?: string | null;
  readonly userId?: number | null;
  readonly startDate?: string | null;
  readonly finishDate?: string | null;
  readonly limit?: number;
  readonly page?: number;
  readonly sortField?: string;
  readonly sortOrder?: 'asc' | 'desc';
}

export async function getAssociatedSearchLogs({
  searchType,
  startDate,
  userId,
  finishDate,
  limit = 10000,
  page = 0,
  sortField,
  sortOrder,
}: getAssociatedSearchLogsProps) {
  const orders = sortField && sortOrder ? [{ field: sortField, sort: sortOrder }] : [{ "field": "created_at", "sort": "desc" }]
  const response = await authFetch({
    url: '/occurrence/associated-search-logs',
    method: 'POST',
    data: {
      search_type: searchType,
      start_date: startDate,
      user_id: userId,
      finish_date: finishDate,
      limit: limit,
      page: page,
      orders: orders
    }
  })

  return response.data
}